<template>
    <div class="admin-user-change-role">
        <a href="#" style="margin-right: 10px; display: inline-block" class="btn btn-secondary btn-sm" @click.prevent="openDialog">Rôle</a>
        <el-dialog
            title="Changer de rôle"
            :visible.sync="dialogue"
            width="70%">
            <p>Changer le rôle de {{ users.length }} utilisateur ?</p>
            <el-select
                v-model="selectedRole"
                placeholder="Select"
                filterable
                clearable
            >
                <el-option
                    v-for="item in roles"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <hr>
            <user-group-component @choice="choiceGroup" :role="selectedRole" :user-group="null"></user-group-component>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">Annuler</el-button>
                <el-button type="primary" @click="submit">Valider</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "BulkUserChangeRole",
    data() {
        return {
            dialogue: false,
            roles: [
                {value: 'admin', label: 'Admin'},
                {value: 'admin_domain', label: 'Admin Domaine'},
                {value: 'pro', label: 'Pro'},
                {value: 'pro+', label: 'Pro+'},
                {value: 'user', label: 'User'},
            ],
            usersInput: [],
            selectedRole: null,
            selectedGroup: null
        }
    },
    computed: {
        users(){
            return Array.from(this.usersInput).map( v => v.value );
        }
    },
    methods: {
        openDialog(){
            this.usersInput = $('input[name="users[]"]:checked')
            if(this.usersInput.length > 0){
                this.dialogue = true
            }
        },
        choiceGroup(group_id) {
            this.selectedGroup = group_id
        },
        submit() {
            this.$confirm('Confirmez-vous le changement de rôle ?', 'Attention', {
                confirmButtonText: 'Valider',
                cancelButtonText: 'Annuler',
                type: 'warning'
            }).then(() => {
                axios.post('/pro/users/change-role', {role: this.selectedRole, group: this.selectedGroup, users: this.users})
                    .then(response => {
                        if(!response.data.success) {
                            this.$message.error(response.data.message)
                        } else {
                            this.$message.success('Rôle changé avec succès')
                            this.dialogue = false
                            window.location.reload()
                        }

                    })
                    .catch(error => {
                        console.log(error);
                    });
            }).catch(() => {
            });

        },
        close() {
            this.dialogue = false
        }
    }
}
</script>

<style scoped>

</style>
